var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 442.75 442.75",
    style: {
      enableBackground: "new 0 0 442.75 442.75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D6889"
    },
    d: "M323.526,79.741c-0.73-3.098-2.662-5.778-5.369-7.452c-2.707-1.673-5.969-2.202-9.066-1.472 L9.244,141.56c-3.098,0.73-5.777,2.662-7.451,5.369c-1.674,2.707-2.203,5.969-1.473,9.066l48.84,207.011 c1.304,5.523,6.231,9.247,11.67,9.247c0.912,0,1.839-0.105,2.766-0.323l299.846-70.741c3.098-0.731,5.777-2.662,7.451-5.369 c1.674-2.707,2.203-5.969,1.473-9.066L323.526,79.741z M325.018,190.589l-51.365-29.836l32.819-48.774L325.018,190.589z  M29.985,177.209l51.161,28.962l-32.614,49.648L29.985,177.209z M44.567,157.885L284.79,101.21l-93.882,139.518L44.567,157.885z  M69.764,345.815l-13.645-57.832l45.959-69.963l86.674,49.065c1.862,1.055,3.895,1.559,5.902,1.559c3.875,0,7.66-1.877,9.965-5.302 l55.604-82.634l72.383,42.044l13.644,57.832L69.764,345.815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D6889"
    },
    d: "M430.75,78.552h-75.393c-6.628,0-12,5.373-12,12c0,6.627,5.372,12,12,12h75.393 c6.628,0,12-5.373,12-12C442.75,83.925,437.378,78.552,430.75,78.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D6889"
    },
    d: "M418.079,139.67h-50.051c-6.628,0-12,5.373-12,12c0,6.627,5.372,12,12,12h50.051 c6.628,0,12-5.373,12-12C430.079,145.043,424.707,139.67,418.079,139.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D6889"
    },
    d: "M406.067,200.788h-26.025c-6.628,0-12,5.373-12,12c0,6.627,5.372,12,12,12h26.025 c6.628,0,12-5.373,12-12C418.067,206.161,412.695,200.788,406.067,200.788z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.8faf754ced220d4d76d25f470af83bbe.svg";
export { ForwardRef as ReactComponent };